import React from 'react';
import PropTypes from 'prop-types';
import BananatagButton from '../../componentLibrary/BananatagButton';
import Modal from '../../componentLibrary/Modal';
import * as Styled from './styles';

const VersionHistoryWarningModal = ({ closeWarningModal, restoreVersion }) => (
    <Modal onEsc={closeWarningModal}>
        <Styled.WarningHeader>Restore version over others</Styled.WarningHeader>
        <Styled.WarningText>
            There are people editing right now. <b>Restoring this version will immediately interrupt their work.</b> If
            needed, the current version can be recovered in version history afterwards.
        </Styled.WarningText>
        <Styled.WarningButtonWrapper>
            <BananatagButton
                type="clear"
                size="large"
                onClick={closeWarningModal}
                text="cancel"
                styling={{ marginRight: 10 }}
            />
            <BananatagButton type="warning" size="large" onClick={restoreVersion} text="restore version" />
        </Styled.WarningButtonWrapper>
    </Modal>
);

VersionHistoryWarningModal.propTypes = {
    closeWarningModal: PropTypes.func.isRequired,
    restoreVersion: PropTypes.func.isRequired,
};

export default VersionHistoryWarningModal;
